import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = ["title", "href"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["title"]
const _hoisted_7 = ["title"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["title"]
const _hoisted_11 = ["title"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["title"]
const _hoisted_15 = ["title"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { key: 3 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { class: "action-list" }
const _hoisted_25 = { class: "dialog-footer" }
const _hoisted_26 = { style: {"color":"rgb(245, 108, 108)","font-size":"12px","white-space":"nowrap","margin-left":"120px","margin-bottom":"18px"} }
const _hoisted_27 = { class: "dialog-footer" }
const _hoisted_28 = {
  class: "error-tip",
  style: {"color":"red","padding-left":"120px"}
}
const _hoisted_29 = { class: "dialog-footer" }
const _hoisted_30 = { class: "dialog-footer" }
const _hoisted_31 = { class: "dialog-footer" }
const _hoisted_32 = {
  class: "error-tip",
  style: {"color":"red","padding-left":"120px"}
}
const _hoisted_33 = { class: "dialog-footer" }
const _hoisted_34 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectBrand = _resolveComponent("SelectBrand")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_SelectCity = _resolveComponent("SelectCity")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SelectBrand, {
        "model-value": _ctx.filters.brand_id,
        onBrandChange: _ctx.onBrandChange,
        "limit-show": true
      }, null, 8, ["model-value", "onBrandChange"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.second_brand_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.second_brand_name) = $event)),
        placeholder: "二级品牌",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.title,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.title) = $event)),
        placeholder: "商品名称",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      (_ctx.filters.goods_type=='1')
        ? (_openBlock(), _createBlock(_component_el_select, {
            key: 0,
            class: "filter-item",
            modelValue: _ctx.filters.status,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.status) = $event)),
            placeholder: "商品状态",
            style: {"width":"170px"},
            clearable: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "全部",
                value: ""
              }),
              _createVNode(_component_el_option, {
                label: "待提交",
                value: "0"
              }),
              _createVNode(_component_el_option, {
                label: "审核中",
                value: "1"
              }),
              _createVNode(_component_el_option, {
                label: "驳回",
                value: "3"
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.filters.goods_type=='2' || _ctx.filters.goods_type=='4')
        ? (_openBlock(), _createBlock(_component_el_select, {
            key: 1,
            class: "filter-item",
            modelValue: _ctx.filters.status,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.status) = $event)),
            placeholder: "商品状态",
            style: {"width":"170px"},
            clearable: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "全部",
                value: ""
              }),
              _createVNode(_component_el_option, {
                label: "下架",
                value: "0"
              }),
              _createVNode(_component_el_option, {
                label: "上架",
                value: "1"
              }),
              _createVNode(_component_el_option, {
                label: "待完善数据",
                value: "-1"
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_select, {
        modelValue: _ctx.filters.cat_id,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.cat_id) = $event)),
        clearable: "",
        filterable: "",
        placeholder: "请选择类型",
        class: "filter-item",
        style: {"width":"150px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "全部",
            value: ""
          }),
          _createVNode(_component_el_option, {
            label: "蛋糕",
            value: "1"
          }),
          _createVNode(_component_el_option, {
            label: "零食",
            value: "5"
          }),
          _createVNode(_component_el_option, {
            label: "鲜花",
            value: "8"
          }),
          _createVNode(_component_el_option, {
            label: "电子券",
            value: "4"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        filterable: "",
        modelValue: _ctx.filters.soldout_type,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.soldout_type) = $event)),
        placeholder: "下架类型",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            value: _ctx.filterTypes['其他'],
            label: "其他"
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            value: _ctx.filterTypes['商品溢价'],
            label: "商品溢价"
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            value: _ctx.filterTypes['折扣不合格'],
            label: "折扣不合格"
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            value: _ctx.filterTypes['信息有误'],
            label: "信息有误"
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            value: _ctx.filterTypes['质量问题'],
            label: "质量问题"
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            value: _ctx.filterTypes['口感不佳'],
            label: "口感不佳"
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            value: _ctx.filterTypes['延迟发货'],
            label: "延迟发货"
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            value: _ctx.filterTypes['品牌资质过期'],
            label: "品牌资质过期"
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            value: _ctx.filterTypes['自行下架'],
            label: "自行下架"
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            value: "9",
            label: "库存不足"
          }),
          _createVNode(_component_el_option, {
            value: "11",
            label: "整改下架"
          }),
          _createVNode(_component_el_option, {
            value: "10",
            label: "永久下架"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_ctx.filters.goods_type=='1')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(_component_el_date_picker, {
              class: "filter-item",
              modelValue: _ctx.filters.start_date,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.start_date) = $event)),
              type: "date",
              "value-format": "YYYY-MM-DD",
              placeholder: "更新开始日期",
              style: {"width":"170px"},
              clearable: ""
            }, null, 8, ["modelValue"]),
            _cache[59] || (_cache[59] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
            _createVNode(_component_el_date_picker, {
              class: "filter-item",
              modelValue: _ctx.filters.end_date,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.end_date) = $event)),
              type: "date",
              "value-format": "YYYY-MM-DD",
              placeholder: "更新结束日期",
              style: {"width":"170px"},
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_input, {
              class: "filter-item",
              modelValue: _ctx.filters.admin_name,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.admin_name) = $event)),
              placeholder: "制单人",
              style: {"width":"170px"},
              clearable: ""
            }, null, 8, ["modelValue"])
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: _ctx.filters.pro_tag,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters.pro_tag) = $event)),
        placeholder: "商品标签",
        style: {"width":"170px"},
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "同城配送",
            value: "同城配送"
          }),
          _createVNode(_component_el_option, {
            label: "全国包邮",
            value: "全国包邮"
          }),
          _createVNode(_component_el_option, {
            label: "当日达",
            value: "当日达"
          }),
          _createVNode(_component_el_option, {
            label: "次日达",
            value: "次日达"
          }),
          _createVNode(_component_el_option, {
            label: "全国配送",
            value: "全国配送"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: _ctx.filters.yushou_start_date,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filters.yushou_start_date) = $event)),
        placeholder: "预售开始时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _cache[73] || (_cache[73] = _createElementVNode("span", { class: "filter-item filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: _ctx.filters.yushou_end_date,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filters.yushou_end_date) = $event)),
        placeholder: "预售结束时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_SelectCity, {
        class: "filter-item",
        multiple: _ctx.multiple,
        onChange: _ctx.onSelectedChange
      }, null, 8, ["multiple", "onChange"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.start_shop_discount,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filters.start_shop_discount) = $event)),
        type: "number",
        min: 0,
        onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.filters.start_shop_discount < 0 ? _ctx.filters.start_shop_discount='':null)),
        title: "折扣必须大于等于0",
        placeholder: "折扣最小价格",
        style: {"display":"inline-flex","width":"200px"},
        clearable: ""
      }, {
        append: _withCtx(() => _cache[60] || (_cache[60] = [
          _createTextVNode("折")
        ])),
        _: 1
      }, 8, ["modelValue"]),
      _cache[74] || (_cache[74] = _createElementVNode("span", { class: "filter-item filter-divider" }, "-", -1)),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.end_shop_discount,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.filters.end_shop_discount) = $event)),
        placeholder: "折扣最大价格",
        type: "number",
        min: 0,
        onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.filters.end_shop_discount < 0 && _ctx.filters.end_shop_discount <= _ctx.filters.start_shop_discount ? _ctx.filters.end_shop_discount='':null)),
        title: "最大折扣价格必须大于等于最小折扣价格",
        style: {"display":"inline-flex","width":"200px"},
        clearable: ""
      }, {
        append: _withCtx(() => _cache[61] || (_cache[61] = [
          _createTextVNode("折")
        ])),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.start_price,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.filters.start_price) = $event)),
        type: "number",
        min: 0,
        onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.filters.start_price < 0 ? _ctx.filters.start_price='':null)),
        title: "价格必须大于等于0",
        placeholder: "售价最小价格",
        style: {"display":"inline-flex","width":"200px"},
        clearable: ""
      }, {
        append: _withCtx(() => _cache[62] || (_cache[62] = [
          _createTextVNode("元")
        ])),
        _: 1
      }, 8, ["modelValue"]),
      _cache[75] || (_cache[75] = _createElementVNode("span", { class: "filter-item filter-divider" }, "-", -1)),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.end_price,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.filters.end_price) = $event)),
        placeholder: "售价最大价格",
        type: "number",
        min: 0,
        onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.filters.end_price < 0 && _ctx.filters.end_price >= _ctx.filters.start_price ? _ctx.filters.end_price='':null)),
        title: "最大价格必须大于等于最小价格",
        style: {"display":"inline-flex","width":"200px"},
        clearable: ""
      }, {
        append: _withCtx(() => _cache[63] || (_cache[63] = [
          _createTextVNode("元")
        ])),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.search()))
      }, {
        default: _withCtx(() => _cache[64] || (_cache[64] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_tooltip, {
        content: "3月6日-3月31日因平台整改，暂停添加商品~",
        placement: "top",
        effect: 'dark',
        disabled: !(_ctx.isSnacks == 2 && _ctx.isBeforeMarch31)
      }, {
        default: _withCtx(() => [
          (_ctx.filters.source !== 1)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "filter-btn",
                type: "primary",
                onClick: _cache[21] || (_cache[21] = ($event: any) => {_ctx.checkAdd(1);}),
                disabled: _ctx.isSnacks == 2 && _ctx.isBeforeMarch31
              }, {
                default: _withCtx(() => _cache[65] || (_cache[65] = [
                  _createTextVNode("添加")
                ])),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["disabled"]),
      (_ctx.filters.source == 2)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 3,
            class: "filter-btn",
            type: "primary",
            onClick: _cache[22] || (_cache[22] = ($event: any) => {_ctx.checkAdd(2);})
          }, {
            default: _withCtx(() => _cache[66] || (_cache[66] = [
              _createTextVNode("批量添加")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.userGroups.includes('21'))
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 4,
            class: "filter-btn",
            type: "primary",
            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.onExport()))
          }, {
            default: _withCtx(() => _cache[67] || (_cache[67] = [
              _createTextVNode("批量导出")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isKd == 0 && (!_ctx.cat_id || _ctx.cat_id == 1))
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 5,
            class: "filter-btn",
            type: "primary",
            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.giftDialogShow = true))
          }, {
            default: _withCtx(() => _cache[68] || (_cache[68] = [
              _createTextVNode("批量上传默认餐具")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.filters.goods_type=='2')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [], 64))
        : _createCommentVNode("", true),
      (!_ctx.userGroups.includes('21') && !_ctx.userGroups.includes('75'))
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 7,
            class: "filter-btn",
            type: "primary",
            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.router.push('/merchant-admin/off-product-list')))
          }, {
            default: _withCtx(() => _cache[69] || (_cache[69] = [
              _createTextVNode("超时下架商品管理")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.filters.source == 1 && !_ctx.userGroups.includes('75'))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
            _createVNode(_component_el_button, {
              class: "filter-btn",
              type: "primary",
              onClick: _ctx.openCouponProductDialog
            }, {
              default: _withCtx(() => _cache[70] || (_cache[70] = [
                _createTextVNode("上传电子券商品")
              ])),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              class: "filter-btn",
              type: "primary",
              onClick: _ctx.onExportProductByBrand
            }, {
              default: _withCtx(() => _cache[71] || (_cache[71] = [
                _createTextVNode("导出上架中的商品")
              ])),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              class: "filter-btn",
              type: "primary",
              onClick: _ctx.openEditPriceDialog
            }, {
              default: _withCtx(() => _cache[72] || (_cache[72] = [
                _createTextVNode("更改商品价格")
              ])),
              _: 1
            }, 8, ["onClick"])
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_el_checkbox, {
        modelValue: _ctx.filters.is_yushou,
        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.filters.is_yushou) = $event)),
        "true-value": "1",
        "false-value": "0",
        label: "预售商品",
        size: "large"
      }, null, 8, ["modelValue"]),
      (_ctx.filters.goods_type=='2')
        ? (_openBlock(), _createBlock(_component_el_checkbox, {
            key: 9,
            modelValue: _ctx.filters.stock,
            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.filters.stock) = $event)),
            "true-value": "1",
            "false-value": "0",
            label: "紧缺商品 ",
            size: "large"
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        style: {"color":"#F56C6C","font-weight":"bold"},
        onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.onPreview && _ctx.onPreview(...args)))
      }, "☆必看，蛋糕添加收费附件操作手册☆")
    ]),
    _createVNode(_component_el_tabs, {
      modelValue: _ctx.filters.goods_type,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.filters.goods_type) = $event)),
      onTabChange: _ctx.onTabChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "全部商品",
          name: "2"
        }),
        (_ctx.filters.source==2)
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 0,
              label: "待上线商品",
              name: "1"
            }))
          : _createCommentVNode("", true),
        (_ctx.filters.source==1)
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 1,
              label: "精选商品",
              name: "3"
            }))
          : _createCommentVNode("", true),
        (_ctx.filters.source==1)
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 2,
              label: "电子券商品",
              name: "4"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onTabChange"]),
    _createVNode(_component_el_table, {
      style: {"position":"relative"},
      ref: "multipleTableRef",
      data: _ctx.tableData,
      stripe: "",
      border: "",
      onSelectionChange: _ctx.onSelectionChange,
      "row-class-name": _ctx.getRowClassName
    }, {
      default: _withCtx(() => [
        ((_ctx.filters.goods_type=='2' || _ctx.filters.goods_type=='3') && _ctx.filters.source==1)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              type: "selection"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          type: "index",
          index: _ctx.tableIndex
        }, null, 8, ["index"]),
        _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "品牌"
        }),
        (_ctx.filters.goods_type!='4')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              prop: "second_brand_name",
              label: "二级品牌"
            }))
          : _createCommentVNode("", true),
        (_ctx.filters.goods_type=='2' || _ctx.filters.goods_type=='4')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              prop: "id",
              label: "商品ID"
            }))
          : _createCommentVNode("", true),
        (_ctx.filters.goods_type!='4')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 3,
              prop: "cat_name",
              label: "所属分类"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "title",
          label: "商品名称"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("a", {
              title: scope.row.title,
              href: `${_ctx.Keys.dsUrl}/h5/product/show?id=${scope.row.id}`,
              target: "_blank"
            }, [
              (scope.row.is_gross && _ctx.filters.goods_type!='4')
                ? (_openBlock(), _createBlock(_component_el_badge, {
                    key: 0,
                    value: "甄选",
                    style: {"position":"absolute","right":"-2px","top":"0px","transform":"rotate(30deg)"}
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(scope.row.title), 1)
            ], 8, _hoisted_3)
          ]),
          _: 1
        }),
        (_ctx.filters.goods_type=='4')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createVNode(_component_el_table_column, {
                prop: "stock",
                label: "库存",
                width: "80"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ color: (scope.row.stock > 0 && scope.row.stock <= 20) ? 'red' : '' })
                  }, _toDisplayString(scope.row.stock === -9999999 ? '无限量':scope.row.stock), 5)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "order_count",
                label: "实际销量",
                width: "80"
              })
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.filters.goods_type!='4')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 5,
              style: {"position":"relative"},
              label: "规格/库存",
              width: "300"
            }, {
              header: _withCtx(() => [
                _cache[76] || (_cache[76] = _createElementVNode("div", null, "规格/口味/库存", -1)),
                (_ctx.lowSalesCount > 0 && _ctx.filters.goods_type == 2)
                  ? (_openBlock(), _createBlock(_component_el_badge, {
                      key: 0,
                      value: _ctx.lowSalesCount,
                      class: _normalizeClass([{ 'large-badge': _ctx.lowSalesCount > 99 }, "low-sales-badge"]),
                      onClick: _withModifiers(_ctx.handleDoubleClick, ["stop"]),
                      max: 9999999999
                    }, null, 8, ["value", "class", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx((scope) => [
                (scope.row.spec_info)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (scope.row.spec_info.length <= 3)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.spec_info, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "flex-start",
                                key: item.id
                              }, [
                                _createElementVNode("span", {
                                  title: item.name,
                                  class: "spec-ellipsis"
                                }, _toDisplayString(item.name), 9, _hoisted_6),
                                _cache[77] || (_cache[77] = _createTextVNode(" / ")),
                                _createElementVNode("span", {
                                  title: item.tastes,
                                  class: "spec-ellipsis"
                                }, _toDisplayString(item.tastes || '无'), 9, _hoisted_7),
                                _cache[78] || (_cache[78] = _createTextVNode(" / ")),
                                _createElementVNode("span", {
                                  style: _normalizeStyle({ color: (item.stock > 0 && item.stock <= 20) ? 'red' : '' })
                                }, _toDisplayString(item.stock === -9999999 ? '无限量':item.stock), 5)
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            (!scope.row.showAll)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.spec_info.slice(0, 3), (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "flex-start",
                                      key: item.id
                                    }, [
                                      _createElementVNode("span", {
                                        title: item.name,
                                        class: "spec-ellipsis"
                                      }, _toDisplayString(item.name), 9, _hoisted_10),
                                      _cache[79] || (_cache[79] = _createTextVNode(" / ")),
                                      _createElementVNode("span", {
                                        title: item.tastes,
                                        class: "spec-ellipsis"
                                      }, _toDisplayString(item.tastes || '无'), 9, _hoisted_11),
                                      _cache[80] || (_cache[80] = _createTextVNode(" / ")),
                                      _createElementVNode("span", {
                                        style: _normalizeStyle({ color: (item.stock > 0 && item.stock <= 20) ? 'red' : '' })
                                      }, _toDisplayString(item.stock === -9999999 ? '无限量':item.stock), 5)
                                    ]))
                                  }), 128)),
                                  _createElementVNode("span", {
                                    style: {"color":"blue"},
                                    onClick: ($event: any) => (_ctx.toggleShowAll(scope.row))
                                  }, "展开", 8, _hoisted_12)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.spec_info, (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "flex-start",
                                      key: item.id
                                    }, [
                                      _createElementVNode("span", {
                                        title: item.name,
                                        class: "spec-ellipsis"
                                      }, _toDisplayString(item.name), 9, _hoisted_14),
                                      _cache[81] || (_cache[81] = _createTextVNode(" / ")),
                                      _createElementVNode("span", {
                                        title: item.tastes,
                                        class: "spec-ellipsis"
                                      }, _toDisplayString(item.tastes || '无'), 9, _hoisted_15),
                                      _cache[82] || (_cache[82] = _createTextVNode(" / ")),
                                      _createElementVNode("span", {
                                        style: _normalizeStyle({ color: (item.stock > 0 && item.stock <= 20) ? 'red' : '' })
                                      }, _toDisplayString(item.stock === -9999999 ? '无限量':item.stock), 5)
                                    ]))
                                  }), 128)),
                                  _createElementVNode("span", {
                                    style: {"color":"blue"},
                                    onClick: ($event: any) => (_ctx.toggleShowAll(scope.row))
                                  }, "收起", 8, _hoisted_16)
                                ]))
                          ]))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.filters.goods_type=='2')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 6,
              prop: "order_count",
              label: "实际销量",
              width: "80"
            }))
          : _createCommentVNode("", true),
        (_ctx.filters.goods_type=='3')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 7,
              prop: "clearing_price",
              label: "结算价",
              width: "80"
            }))
          : _createCommentVNode("", true),
        (_ctx.filters.goods_type !='3')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 8,
              prop: "market_price",
              label: "市场价",
              width: "80"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "price",
          label: "售价",
          width: "80"
        }),
        _createVNode(_component_el_table_column, {
          prop: "shop_discount",
          label: "折扣",
          width: "80"
        }),
        (_ctx.filters.goods_type=='4')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 9,
              prop: "clearing_price",
              label: "结算价",
              width: "80"
            }))
          : _createCommentVNode("", true),
        (_ctx.filters.goods_type !='3' && _ctx.filters.goods_type !='4')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 10,
              prop: "label_name",
              label: "商品标签",
              width: "80"
            }))
          : _createCommentVNode("", true),
        (_ctx.filters.goods_type !='3' && _ctx.filters.goods_type !='4')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 11,
              label: "下架类型",
              prop: "soldout_type_text",
              width: "80"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          label: "商品状态",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (_ctx.filters.goods_type=='1')
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.CheckStatus[scope.row.check_status]), 1))
              : (_ctx.filters.goods_type=='4')
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                    (scope.row.status == 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, "下架"))
                      : (scope.row.status == 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, "上架"))
                        : (scope.row.status == -1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, "待完善数据"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_22))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(scope.row.status == 0 ? '下架' :scope.row.status == 1 ? '上架' : '待完善数据'), 1))
          ]),
          _: 1
        }),
        (_ctx.filters.goods_type=='1')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 12 }, [
              _createVNode(_component_el_table_column, {
                prop: "admin_name",
                label: "制单人"
              }),
              _createVNode(_component_el_table_column, {
                prop: "created_at",
                label: "更新时间",
                width: "140"
              })
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.filters.goods_type=='2')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 13 }, [
              _createVNode(_component_el_table_column, {
                label: "上线时间",
                width: "140",
                prop: "putaway_time"
              }),
              _createVNode(_component_el_table_column, {
                label: "更新时间",
                width: "140",
                prop: "updated_at"
              }),
              _createVNode(_component_el_table_column, {
                label: "创建时间",
                width: "140",
                prop: "created_at"
              })
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.filters.goods_type=='4')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 14 }, [
              _createVNode(_component_el_table_column, {
                label: "上线时间",
                width: "140",
                prop: "putaway_time"
              }),
              _createVNode(_component_el_table_column, {
                label: "更新时间",
                width: "140",
                prop: "updated_at"
              }),
              _createVNode(_component_el_table_column, {
                label: "创建时间",
                width: "140",
                prop: "created_at"
              })
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.yushouTime == 1 && _ctx.filters.goods_type !='4')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 15,
              label: "预售时间",
              width: "90px"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.yushou_date) + "至" + _toDisplayString(scope.row.yushou_end_date), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "140",
          fixed: "right"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (_ctx.toEdit(scope.row, 'view'))
              }, {
                default: _withCtx(() => _cache[83] || (_cache[83] = [
                  _createTextVNode("查看")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              (!_ctx.userGroups.includes('75'))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (_ctx.toEdit(scope.row, 'edit')),
                    disabled: _ctx.CheckStatus[scope.row.check_status] === '审核中' || _ctx.CheckStatus[scope.row.check_status] === '审核通过'
                  }, {
                    default: _withCtx(() => _cache[84] || (_cache[84] = [
                      _createTextVNode("编辑")
                    ])),
                    _: 2
                  }, 1032, ["onClick", "disabled"]))
                : _createCommentVNode("", true),
              (_ctx.CheckStatus[scope.row.check_status] === '审核中' && _ctx.filters.source==2)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "warning",
                    size: "small",
                    onClick: ($event: any) => (_ctx.onRollback(scope.row.save_id))
                  }, {
                    default: _withCtx(() => _cache[85] || (_cache[85] = [
                      _createTextVNode("撤销")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (scope.row.brand_id == 101528 || scope.row.brand_id == 101598)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 2,
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (_ctx.toConfig(scope.row))
                  }, {
                    default: _withCtx(() => _cache[86] || (_cache[86] = [
                      _createTextVNode("配置SKU")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.filters.goods_type=='2' && !_ctx.userGroups.includes('75'))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    (scope.row.status == 1)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          size: "small",
                          onClick: ($event: any) => (_ctx.onChangeStatus(scope.row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.row.status == 0 ? '上架' : '下架'), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (!_ctx.userGroups.includes('75'))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 4,
                    type: "primary",
                    size: "small",
                    class: "mt8",
                    disabled: _ctx.filters.goods_type=='1' && _ctx.CheckStatus[scope.row.check_status] != '未提交',
                    title: _ctx.filters.goods_type=='1' && _ctx.CheckStatus[scope.row.check_status] != '未提交' ? '未提交审核或审核通过后才能修改开通城市' : '',
                    onClick: ($event: any) => (_ctx.toEditCity(scope.row))
                  }, {
                    default: _withCtx(() => _cache[87] || (_cache[87] = [
                      _createTextVNode(" 修改开通城市 ")
                    ])),
                    _: 2
                  }, 1032, ["disabled", "title", "onClick"]))
                : _createCommentVNode("", true),
              (_ctx.filters.source == 1 && !_ctx.userGroups.includes('75'))
                ? (_openBlock(), _createBlock(_component_el_dropdown, {
                    key: 5,
                    class: "mt8"
                  }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_dropdown_item, {
                            onClick: ($event: any) => (_ctx.intervene(scope.row))
                          }, {
                            default: _withCtx(() => _cache[89] || (_cache[89] = [
                              _createTextVNode("销量干预")
                            ])),
                            _: 2
                          }, 1032, ["onClick"]),
                          (_ctx.filters.source==1 && (_ctx.userGroups.includes('1') || _ctx.userGroups.includes('56')) && _ctx.filters.goods_type != '4')
                            ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                key: 0,
                                onClick: ($event: any) => (_ctx.setDistributionRule(scope.row))
                              }, {
                                default: _withCtx(() => _cache[90] || (_cache[90] = [
                                  _createTextVNode("设置配送规则")
                                ])),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true),
                          (_ctx.filters.source==1 && _ctx.filters.goods_type != '4')
                            ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                key: 1,
                                onClick: ($event: any) => (_ctx.addComment(scope.row))
                              }, {
                                default: _withCtx(() => _cache[91] || (_cache[91] = [
                                  _createTextVNode("添加评论")
                                ])),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[88] || (_cache[88] = [
                          _createTextVNode(" 更多 "),
                          _createElementVNode("i", { class: "el-icon-arrow-down" }, null, -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "onSelectionChange", "row-class-name"]),
    _createVNode(_component_Pagination, {
      currentPage: _ctx.filters.page,
      total: _ctx.total,
      onPageChange: _ctx.onPageChange,
      onSizeChange: _ctx.onSizeChange
    }, null, 8, ["currentPage", "total", "onPageChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "配置商品规格城市、SKU",
      width: 1100,
      modelValue: _ctx.SkuDialogVisible,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.SkuDialogVisible) = $event)),
      "before-close": _ctx.SkuDialogVisibleClose
    }, {
      footer: _withCtx((scope) => [
        _createElementVNode("span", _hoisted_25, [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.updateRow(_ctx.product_id)))
          }, {
            default: _withCtx(() => _cache[93] || (_cache[93] = [
              _createTextVNode("保存")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: _ctx.addRow
          }, {
            default: _withCtx(() => _cache[94] || (_cache[94] = [
              _createTextVNode("添加")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _ctx.goods,
          border: "",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { type: "index" }),
            _createVNode(_component_el_table_column, {
              label: "规格",
              prop: "brand_name"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_select, {
                  modelValue: scope.row.specs_id,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.specs_id) = $event),
                  placeholder: "请选择规格",
                  onChange: ($event: any) => (_ctx.checkForDuplicateSpecs(scope.row.specs_id)),
                  filterable: "",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specsList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id,
                        disabled: Boolean(item.deleted)
                      }, null, 8, ["label", "value", "disabled"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "SKU",
              prop: "stock_num"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_input, {
                  modelValue: scope.row.sku,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.sku) = $event),
                  placeholder: "请输入SKU",
                  onInput: ($event: any) => (scope.row.sku = scope.row.sku.replace(/[^0-9a-zA-Z_\-.!@#$%^&*()+,?/]/g, '')),
                  clearable: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "城市" }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_select_v2, {
                  class: "filter-item",
                  filterable: "",
                  modelValue: scope.row.city_list,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.city_list) = $event),
                  clearable: "",
                  multiple: "",
                  options: _ctx.cityList,
                  placeholder: "请选择城市",
                  props: _ctx.cityListProps,
                  onChange: ($event: any) => (_ctx.isCityDisabled(scope.row.specs_id))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "props", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: 80
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  type: "danger",
                  size: "small",
                  onClick: ($event: any) => (_ctx.removeRow(scope.$index))
                }, {
                  default: _withCtx(() => _cache[92] || (_cache[92] = [
                    _createTextVNode("删除")
                  ])),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      title: "下架原因",
      modelValue: _ctx.productShelfShow,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.productShelfShow) = $event)),
      "before-close": _ctx.onProductShelfShow
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_27, [
          _createVNode(_component_el_button, { onClick: _ctx.onProductShelfShow }, {
            default: _withCtx(() => _cache[95] || (_cache[95] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.saveStatus(_ctx.shelf.product_ids,_ctx.shelf.status)))
          }, {
            default: _withCtx(() => _cache[96] || (_cache[96] = [
              _createTextVNode("确 定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.shelf,
          "label-width": "120px",
          ref: "shelfProductForm",
          rules: _ctx.shelfRule
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "下架类型",
              prop: "soldout_type",
              style: _normalizeStyle({display: 'flex',alignItems: 'center',marginBottom: _ctx.showPermanentTip ? '7px' : '18px'})
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  style: {"width":"300px"},
                  onChange: _ctx.handleSoldoutTypeChange,
                  filterable: "",
                  modelValue: _ctx.shelf.soldout_type,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.shelf.soldout_type) = $event)),
                  placeholder: "下架类型",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: _ctx.offTypes['商品溢价'],
                      label: "商品溢价"
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.offTypes['折扣不合格'],
                      label: "折扣不合格"
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.offTypes['信息有误'],
                      label: "信息有误"
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.offTypes['质量问题'],
                      label: "质量问题"
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.offTypes['口感不佳'],
                      label: "口感不佳"
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.offTypes['整改下架'],
                      label: "整改下架"
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.offTypes['永久下架'],
                      label: "永久下架"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["onChange", "modelValue"])
              ]),
              _: 1
            }, 8, ["style"]),
            _withDirectives(_createElementVNode("div", _hoisted_26, " 注：永久下架后，该商品不可再提交审批及上架 ", 512), [
              [_vShow, _ctx.showPermanentTip]
            ]),
            _createVNode(_component_el_form_item, { label: "下架原因" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: _ctx.shelf.soldout_reson,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.shelf.soldout_reson) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "下架原因",
                  maxlength: "100",
                  rows: 4,
                  "show-word-limit": "",
                  style: {"width":"400px"},
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      title: "批量添加",
      modelValue: _ctx.productDialogShow,
      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.productDialogShow) = $event)),
      "before-close": _ctx.onProductUploadCancel
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_29, [
          _createVNode(_component_el_button, { onClick: _ctx.onProductUploadCancel }, {
            default: _withCtx(() => _cache[99] || (_cache[99] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _ctx.onProductUploadCancel
          }, {
            default: _withCtx(() => _cache[100] || (_cache[100] = [
              _createTextVNode("确 定")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "form bordered",
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "品牌" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select_v2, {
                  modelValue: _ctx.brandId,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.brandId) = $event)),
                  filterable: "",
                  clearable: "",
                  options: _ctx.brandList,
                  props: _ctx.brandProps
                }, null, 8, ["modelValue", "options", "props"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "上传文件" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "upload-demo",
                  ref: "batchProductForm",
                  action: `/api/cake_api/do_import?user_id=${_ctx.store.state.user.userInfo.id}&brand_id=${_ctx.brandId}`,
                  "before-upload": _ctx.onProductBeforeUpload,
                  "on-success": _ctx.onProductUploadSuccess,
                  accept: ".xls,.xlsx"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[97] || (_cache[97] = [
                        _createTextVNode("点击上传")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["action", "before-upload", "on-success"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  href: `${_ctx.Keys.baseUrl}/cake_api/get_addGoods_mb?user_id=${_ctx.store.state.user.userInfo.id}`,
                  type: "primary"
                }, {
                  default: _withCtx(() => _cache[98] || (_cache[98] = [
                    _createTextVNode("下载批量添加模版")
                  ])),
                  _: 1
                }, 8, ["href"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.uploadProductList.length)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: _ctx.uploadProductList,
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "title",
                  label: "商品名称"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "cat_name",
                  label: "品类"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "market_price",
                  label: "市场价"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "price",
                  label: "售价"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "shop_discount",
                  label: "商户折扣"
                })
              ]),
              _: 1
            }, 8, ["data"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.errorMsg), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      title: "客服批量添加",
      modelValue: _ctx.ServiceProductDialogShow,
      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.ServiceProductDialogShow) = $event)),
      "close-on-click-modal": false,
      "before-close": _ctx.onServiceProductUploadCancel
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_30, [
          _createVNode(_component_el_button, { onClick: _ctx.onServiceProductUploadCancel }, {
            default: _withCtx(() => _cache[103] || (_cache[103] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _ctx.ServiceDialogSubmit
          }, {
            default: _withCtx(() => _cache[104] || (_cache[104] = [
              _createTextVNode("确 定")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "form bordered",
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "上传文件" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "upload-demo",
                  ref: "ServiceBatchProductForm",
                  action: `/api/cake_api/do_product_import?user_id=${_ctx.store.state.user.userInfo.id}`,
                  "on-success": _ctx.onServiceUploadSuccess,
                  "file-list": _ctx.fileList,
                  accept: ".xls,.xlsx",
                  "auto-upload": false,
                  onChange: _ctx.handleServiceFileChange,
                  "on-remove": _ctx.handleServiceFileRemove
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      disabled: _ctx.serviceUploadSuccess
                    }, {
                      default: _withCtx(() => _cache[101] || (_cache[101] = [
                        _createTextVNode("点击上传")
                      ])),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["action", "on-success", "file-list", "onChange", "on-remove"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  href: `${_ctx.Keys.baseUrl}/cake_api/get_Goods_mb?user_id=${_ctx.store.state.user.userInfo.id}`,
                  type: "primary"
                }, {
                  default: _withCtx(() => _cache[102] || (_cache[102] = [
                    _createTextVNode("下载批量添加模版")
                  ])),
                  _: 1
                }, 8, ["href"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      title: "批量修改",
      modelValue: _ctx.priceDialogShow,
      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.priceDialogShow) = $event)),
      "before-close": _ctx.beforePriceDialogClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_31, [
          _createVNode(_component_el_button, { onClick: _ctx.beforePriceDialogClose }, {
            default: _withCtx(() => _cache[110] || (_cache[110] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.submitUpload()))
          }, {
            default: _withCtx(() => _cache[111] || (_cache[111] = [
              _createTextVNode("确 定")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.submitUpload()))
          }, {
            default: _withCtx(() => _cache[112] || (_cache[112] = [
              _createTextVNode("确定并提交上架审核")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "form",
          "label-width": "150px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "批量修改",
              prop: "image"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "avatar-uploader",
                  ref: "batchDeliveryForm",
                  action: _ctx.batchChangePriceUrl,
                  "show-file-list": true,
                  "on-success": _ctx.onAvatarSuccess,
                  "before-upload": _ctx.beforeAvatarUpload,
                  "auto-upload": false
                }, {
                  default: _withCtx(() => [
                    _cache[105] || (_cache[105] = _createElementVNode("i", { class: "el-icon-plus avatar-uploader-icon" }, "选取文件", -1)),
                    _createElementVNode("p", null, _toDisplayString(_ctx.file.name), 1),
                    _cache[106] || (_cache[106] = _createElementVNode("p", { style: {"color":"red"} }, "注：只能修改状态为未提交、上架、下架的商品", -1))
                  ]),
                  _: 1
                }, 8, ["action", "on-success", "before-upload"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "定时上架：",
              prop: "is_time"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.is_time,
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.is_time) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => _cache[107] || (_cache[107] = [
                        _createTextVNode("是")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 0 }, {
                      default: _withCtx(() => _cache[108] || (_cache[108] = [
                        _createTextVNode("否")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_ctx.is_time)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "上架时间："
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.examine_time,
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.examine_time) = $event)),
                      type: "date",
                      "disabled-date": _ctx.disabledPreSaleDate,
                      "value-format": "YYYY-MM-DD",
                      placeholder: "上架日期"
                    }, null, 8, ["modelValue", "disabled-date"]),
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.hour,
                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.hour) = $event)),
                      placeholder: "上架时间"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hourList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item,
                            label: item,
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  href: `${_ctx.Keys.baseUrl}/admin/shop_product/downLoadExcel`,
                  type: "primary"
                }, {
                  default: _withCtx(() => _cache[109] || (_cache[109] = [
                    _createTextVNode("下载批量修改模版")
                  ])),
                  _: 1
                }, 8, ["href"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      title: "批量上传默认餐具",
      modelValue: _ctx.giftDialogShow,
      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.giftDialogShow) = $event)),
      "before-close": _ctx.dialogBeforeCloseGift,
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: _ctx.dialogBeforeCloseGift }, {
          default: _withCtx(() => _cache[115] || (_cache[115] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.dialogSubmit
        }, {
          default: _withCtx(() => _cache[116] || (_cache[116] = [
            _createTextVNode("确 定")
          ])),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "inForm",
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "上传文件" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "upload-demo",
                  ref: "uploadRef",
                  action: `/api/cake_api/do_import_canju?user_id=${_ctx.store.state.user.userInfo.id}&user_name=${_ctx.store.state.user.userInfo.username}`,
                  "on-success": _ctx.onUploadSuccess,
                  accept: ".xls,.xlsx",
                  "file-list": _ctx.fileList,
                  "auto-upload": false,
                  limit: 1,
                  onChange: _ctx.handleFileChange
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      disabled: _ctx.fileList.length >= 1
                    }, {
                      default: _withCtx(() => _cache[113] || (_cache[113] = [
                        _createTextVNode("点击上传")
                      ])),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["action", "on-success", "file-list", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  href: `${_ctx.Keys.baseUrl}/cake_api/get_canju_mb?user_id=${_ctx.store.state.user.userInfo.id}`
                }, {
                  default: _withCtx(() => _cache[114] || (_cache[114] = [
                    _createTextVNode("下载批量添加模版")
                  ])),
                  _: 1
                }, 8, ["href"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      title: _ctx.currentRow.title,
      modelValue: _ctx.cityDialogShow,
      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.cityDialogShow) = $event)),
      "before-close": _ctx.onCityDialogClose
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.onCitySubmit
        }, {
          default: _withCtx(() => _cache[119] || (_cache[119] = [
            _createTextVNode("确定")
          ])),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "120px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.cityRadio,
                  "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.cityRadio) = $event)),
                  class: "flex-radio-group"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      value: 1,
                      size: "large"
                    }, {
                      default: _withCtx(() => _cache[117] || (_cache[117] = [
                        _createTextVNode("开通品牌配置 所有城市")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      value: 2,
                      size: "large"
                    }, {
                      default: _withCtx(() => _cache[118] || (_cache[118] = [
                        _createTextVNode("配置开通城市")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                (_ctx.cityRadio == 2)
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 0,
                      modelValue: _ctx.brandCityList,
                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.brandCityList) = $event)),
                      filterable: "",
                      multiple: "",
                      placeholder: "请选择",
                      width: "100px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox, {
                          class: "el-select_checkbox",
                          modelValue: _ctx.isSelectedAll,
                          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.isSelectedAll) = $event)),
                          indeterminate: _ctx.isIndeterminate,
                          value: "全选",
                          onChange: _ctx.onIsSelectedAllChange
                        }, null, 8, ["modelValue", "indeterminate", "onChange"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newCityList, (group) => {
                          return (_openBlock(), _createBlock(_component_el_option_group, {
                            key: group.lable,
                            label: group.lable
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.lable,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title", "modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      title: "销量",
      modelValue: _ctx.salesNumDialogShow,
      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.salesNumDialogShow) = $event)),
      "before-close": _ctx.onSalesNumClose
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.onSalesNumSubmit
        }, {
          default: _withCtx(() => _cache[120] || (_cache[120] = [
            _createTextVNode("确定")
          ])),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "120px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "" }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.currentRow.title), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "当前销量" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.currentRow.buy_count,
                  "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.currentRow.buy_count) = $event)),
                  type: "number",
                  min: "0",
                  placeholder: "请输入当前销量",
                  onInput: _cache[51] || (_cache[51] = ($event: any) => (_ctx.currentRow.buy_count = _ctx.currentRow.buy_count.replace(/[^0-9.]/g, '')))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "实际销量" }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.currentRow.order_count), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      title: "添加评论",
      modelValue: _ctx.commentDialogShow,
      "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.commentDialogShow) = $event)),
      "before-close": () => { _ctx.commentDialogShow = false }
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.commentDialogShow = false))
        }, {
          default: _withCtx(() => _cache[122] || (_cache[122] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.saveComments
        }, {
          default: _withCtx(() => _cache[123] || (_cache[123] = [
            _createTextVNode("保存")
          ])),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "120px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "商品名称" }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.currentProduct.title), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "商品ID" }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.currentProduct.id), 1)
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "comment-item"
              }, [
                _createElementVNode("h4", null, "评论 " + _toDisplayString(index + 1), 1),
                _createVNode(_component_el_form_item, { label: "口感评分" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: item.taste_score,
                      "onUpdate:modelValue": ($event: any) => ((item.taste_score) = $event),
                      placeholder: "请选择"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                          return _createVNode(_component_el_option, {
                            key: n,
                            label: n,
                            value: n.toString()
                          }, null, 8, ["label", "value"])
                        }), 64))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_el_form_item, { label: "准时评分" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: item.ontime_score,
                      "onUpdate:modelValue": ($event: any) => ((item.ontime_score) = $event),
                      placeholder: "请选择"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                          return _createVNode(_component_el_option, {
                            key: n,
                            label: n,
                            value: n.toString()
                          }, null, 8, ["label", "value"])
                        }), 64))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_el_form_item, { label: "详情评分" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: item.detailed_score,
                      "onUpdate:modelValue": ($event: any) => ((item.detailed_score) = $event),
                      placeholder: "请选择"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                          return _createVNode(_component_el_option, {
                            key: n,
                            label: n,
                            value: n.toString()
                          }, null, 8, ["label", "value"])
                        }), 64))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_el_form_item, { label: "服务评分" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: item.service_score,
                      "onUpdate:modelValue": ($event: any) => ((item.service_score) = $event),
                      placeholder: "请选择"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                          return _createVNode(_component_el_option, {
                            key: n,
                            label: n,
                            value: n.toString()
                          }, null, 8, ["label", "value"])
                        }), 64))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_el_form_item, { label: "评论内容" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "textarea",
                      modelValue: item.comment,
                      "onUpdate:modelValue": ($event: any) => ((item.comment) = $event),
                      placeholder: "请输入评论内容",
                      rows: 3
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_el_divider)
              ]))
            }), 128)),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _ctx.addMoreComments
            }, {
              default: _withCtx(() => _cache[121] || (_cache[121] = [
                _createTextVNode("添加更多")
              ])),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      title: "批量上传电子券商品",
      modelValue: _ctx.couponProductDialog,
      "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.couponProductDialog) = $event)),
      "before-close": _ctx.couponProductDialogClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_33, [
          _createVNode(_component_el_button, { onClick: _ctx.couponProductDialogClose }, {
            default: _withCtx(() => _cache[126] || (_cache[126] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }, 8, ["onClick"]),
          (_ctx.couponProductList.length == 0)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                onClick: _ctx.onCouponProductUpload
              }, {
                default: _withCtx(() => _cache[127] || (_cache[127] = [
                  _createTextVNode("上传")
                ])),
                _: 1
              }, 8, ["onClick"]))
            : (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "success",
                onClick: _ctx.onCouponProductUploadSure
              }, {
                default: _withCtx(() => _cache[128] || (_cache[128] = [
                  _createTextVNode("保存")
                ])),
                _: 1
              }, 8, ["onClick"]))
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "form bordered",
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "品牌" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select_v2, {
                  modelValue: _ctx.couponProductBrandId,
                  "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.couponProductBrandId) = $event)),
                  filterable: "",
                  clearable: "",
                  options: _ctx.couponBrandList,
                  props: _ctx.brandProps
                }, null, 8, ["modelValue", "options", "props"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "上传文件" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tooltip, {
                  disabled: !_ctx.couponProductBrandId || _ctx.couponProductFile,
                  content: "只有选择品牌之后才可以上传文件且文件只能上传一个",
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_upload, {
                        class: "upload-demo",
                        ref: "uploadRef",
                        action: "none",
                        "on-exceed": _ctx.onFileExceed,
                        "on-change": _ctx.onFileChange,
                        "on-remove": _ctx.onFileRemove,
                        "file-list": _ctx.fileList,
                        accept: ".xls,.xlsx",
                        limit: 1,
                        "auto-upload": false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "small",
                            disabled: !_ctx.couponProductBrandId || _ctx.couponProductFile
                          }, {
                            default: _withCtx(() => _cache[124] || (_cache[124] = [
                              _createTextVNode("上传表格")
                            ])),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["on-exceed", "on-change", "on-remove", "file-list"])
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  href: `${_ctx.Keys.baseUrl}/opsapi/get_coupon_mb?Access_token=${_ctx.store.state.user.userInfo.access_token}`,
                  type: "primary"
                }, {
                  default: _withCtx(() => _cache[125] || (_cache[125] = [
                    _createTextVNode("下载上传模版")
                  ])),
                  _: 1
                }, 8, ["href"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.couponProductList.length)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: _ctx.couponProductList,
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "cat_name",
                  label: "类型"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "brand_id",
                  label: "品牌ID"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "brand_name",
                  label: "品牌名称"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "title",
                  label: "商品名称"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "description",
                  label: "商品描述"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "market_price",
                  label: "市场价"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "price",
                  label: "售价"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "spec_name",
                  label: "规格名称"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "spec_description",
                  label: "规格描述"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "spec_market_price",
                  label: "规格市场价"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "spec_price",
                  label: "规格售价"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "spec_clearing_price",
                  label: "规格结算价"
                })
              ]),
              _: 1
            }, 8, ["data"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.couponProductErrorMsg), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      title: "商品改价",
      modelValue: _ctx.editPriceDialog,
      "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.editPriceDialog) = $event)),
      "before-close": _ctx.editPriceFormDialogClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_34, [
          _createVNode(_component_el_button, { onClick: _ctx.editPriceFormDialogClose }, {
            default: _withCtx(() => _cache[130] || (_cache[130] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.onEditPriceUpload
          }, {
            default: _withCtx(() => _cache[131] || (_cache[131] = [
              _createTextVNode("保存")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "form bordered",
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "品牌" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select_v2, {
                  modelValue: _ctx.editPriceBrandId,
                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.editPriceBrandId) = $event)),
                  filterable: "",
                  clearable: "",
                  options: _ctx.brandList,
                  props: _ctx.brandProps
                }, null, 8, ["modelValue", "options", "props"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "上传文件" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "upload-demo",
                  ref: "uploadRef",
                  action: "none",
                  "on-exceed": _ctx.onEditPriceFileExceed,
                  "on-change": _ctx.onEditPriceFileChange,
                  "on-remove": _ctx.onEditPriceFileRemove,
                  "file-list": _ctx.editPriceFileList,
                  accept: ".xls,.xlsx",
                  limit: 1,
                  "auto-upload": false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[129] || (_cache[129] = [
                        _createTextVNode("上传表格")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["on-exceed", "on-change", "on-remove", "file-list"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ]))
}